import { __extends } from "tslib";
// DS: CR18S
import React from 'react';
import { withTranslation, Trans } from 'react-i18next';
import { Url } from '@wix/da-url';
import { NotificationType } from '../../Notifications/redux/types';
import Notification from '../../Notifications/Notification';
import SystemNotification from '../../SystemNotification';
import AddToFaveIcon from '@wix/da-ds/pkg/Icons/24x24/AddedToFav';
import RemoveFaveIcon from '@wix/da-ds/pkg/Icons/24x24/RemovedFromFav';
import CheckIcon from '@wix/da-ds/pkg/Icons/Check';
import { getDeviationNotificationQueue } from '../../DeviationPage/redux/helpers';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { ResourceType } from '../../types/resource';
import { GallectionResourceType } from '../../types/gallection';
import { BiContextProvidedValue, BiData, } from '@wix/da-bi/pkg/events';
var keys = {
    addOne: 'collectionPanel.notification.addedToCollection.v2',
    addMany: 'collectionPanel.notification.addedToCollection.multi.v2',
    removeOne: 'collectionPanel.notification.removedFromCollection.v2',
    removeSome: 'collectionPanel.notification.removedFromCollection.multi.v2',
    removeAll: 'collectionPanel.notification.removedFromAllCollections.v2',
    misc: 'collectionPanel.notification.miscChanges.v2',
    none: '',
};
var undoMap = {
    removeOne: 'addOne',
    removeSome: 'addMany',
    removeAll: 'addMany',
    addOne: 'removeOne',
    addMany: 'removeSome',
    misc: 'misc',
    none: 'none',
};
export var SCROLL_TO_FOLDER_HASH_SIGNAL = 'scrollIntoView';
var CollectNotification = /** @class */ (function (_super) {
    __extends(CollectNotification, _super);
    function CollectNotification() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onUndo = function () {
            var _a = _this.props, deviationId = _a.collectedDeviation.deviationId, onUndo = _a.onUndo, removeNotification = _a.removeNotification, id = _a.id;
            onUndo(deviationId);
            removeNotification(id);
        };
        return _this;
    }
    CollectNotification.prototype.render = function () {
        var _a = this.props, id = _a.id, collectedDeviation = _a.collectedDeviation, queueName = _a.queueName, addNotification = _a.addNotification;
        return (React.createElement(Notification, { id: id, queueName: queueName, cardComponent: SystemNotification, cardProps: {
                iconComponent: this.getIcon(),
                backgroundDeviation: collectedDeviation,
            }, onClose: queueName === getDeviationNotificationQueue(collectedDeviation) &&
                !this.isUndo()
                ? function () { return addNotification(queueName, 'commentReminder', {}); }
                : undefined }, this.renderTitle()));
    };
    CollectNotification.prototype.getIcon = function () {
        var changeType = this.props.changeType;
        switch (changeType) {
            case 'removeAll':
            case 'removeOne':
            case 'removeSome':
                return RemoveFaveIcon;
            case 'addMany':
            case 'addOne':
                return AddToFaveIcon;
            default:
                return CheckIcon;
        }
    };
    CollectNotification.prototype.renderTitle = function () {
        var _a;
        var _b = this.props, changeType = _b.changeType, changedFolderCount = _b.changedFolderCount, t = _b.t, exampleCollection = _b.exampleCollection, currentUser = _b.currentUser;
        var effectiveChange = this.isUndo() ? undoMap[changeType] : changeType;
        var key = keys[effectiveChange];
        if (!key || !currentUser) {
            return null;
        }
        switch (effectiveChange) {
            case 'addOne':
            case 'removeOne':
                var collection = exampleCollection
                    ? exampleCollection.name
                    : t('collectionPanel.aCollection');
                var url = exampleCollection
                    ? Url.userGalleryLink({
                        username: currentUser.username,
                        gallectionType: 'collection',
                        folderId: exampleCollection.folderId,
                        folderName: exampleCollection.name,
                    })
                    : Url.userGalleryLink({
                        username: currentUser.username,
                        gallectionType: 'collection',
                    });
                var biData = BiData({
                    evid: 100,
                    itemid: (_a = exampleCollection === null || exampleCollection === void 0 ? void 0 : exampleCollection.folderId) !== null && _a !== void 0 ? _a : currentUser.userId,
                    typeid: exampleCollection
                        ? GallectionResourceType.COLLECTION
                        : ResourceType.USER,
                    sectionid: BiContextProvidedValue,
                    sectionname: BiContextProvidedValue,
                    section_typeid: BiContextProvidedValue,
                    sectiontype: BiContextProvidedValue,
                    widgetname: BiContextProvidedValue,
                });
                return (
                // prettier-ignore
                React.createElement(Trans, { i18nKey: key },
                    "Changed in ",
                    React.createElement(BiLink, { biData: biData, href: "".concat(url, "#").concat(SCROLL_TO_FOLDER_HASH_SIGNAL) }, { collection: collection })));
            default:
                return t(key, { changedFolderCount: changedFolderCount });
        }
    };
    CollectNotification.prototype.isUndo = function () {
        return this.props.type === NotificationType.CollectUndo;
    };
    return CollectNotification;
}(React.Component));
export { CollectNotification };
export default withTranslation()(CollectNotification);
//# sourceMappingURL=CollectNotification.js.map